import React, { useState, useEffect } from 'react'
import Loader from '../../../../presentationals/Loader/Loader.component';
import PiePage from '../CommonComponents/PiePage.component'
import InputField from '../CommonComponents/InputMUI'
import SelectField from '../CommonComponents/SelectMUI';
import MultiSelect from '../CommonComponents/MultiSelectMUI'
import moment from 'moment';
import Popup from '../../../../presentationals/Popup/Popup.component'
import { APIS } from '../api-factory';
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import { POST_HEADER } from '../../../../../utils/apiHeaders';

const actionTypeData = [

    { name: "URL", code: "URL" },
    { name: "SCREEN", code: "SCREEN" },
]
const isActiveData = [
    { name: "Yes", code: true },
    { name: "No", code: false },
]

const priorityData = [

    { name: "0", code: "0" },
    { name: "1", code: "1" },
    { name: "2", code: "2" },
    { name: "3", code: "3" },
    { name: "4", code: "4" },
    { name: "5", code: "5" },
]



export default function AddDocument({ handleEdit,Editdata }) {
    const [loader, setLoader] = useState(false)
    const [responseMsg, setResponseMsg] = useState("")
    const [errors, setErrors] = useState({});
    const [nameData, setNameData] = useState([])
    const [showPopup, setShowPopup] = useState({ show: false, popupStatus: "" })
    const [objectDataNew, setobjectDataNew] = useState({
        title: "",
        description: "",
        actionType: "",
        actionValue: '',
        priority: '',
        imageUrl: '',
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
        isActive: '',

    })

    useEffect(() => {
        console.log("Editdata", Editdata)
        if (Editdata?.id) {

            setobjectDataNew({
                title: Editdata?.title || "",
                description: Editdata?.description || "",
                actionType: Editdata?.actionType || "",
                actionValue: Editdata?.actionValue || '',
                priority: Editdata?.priority || '',
                imageUrl: Editdata?.imageUrl,
                startDate: Editdata?.startDate || '',
                endDate: Editdata?.endDate || '',
                isActive: Editdata?.isActive || '',


            })
        } else {
            setobjectDataNew({
                title: "",
                description: "",
                actionType: "",
                actionValue: '',
                priority: '',
                imageUrl: '',
                startDate: '',
                endDate: '',
                isActive: '',
            })
        }
    }, [Editdata])





    const inputChange = (e, type) => {

        if (type == "imageUrl") {
            console.log(e.target.files, type)
            const file = e.target.files[0];

            if (!file) return;
            setLoader(true)
            uploadFileAPI(file)
                .then((res) => {
                    setShowPopup({ show: true, popupStatus: 'Image Uploaded Successfully' })
                    const imageUrl = res?.url || res;
                    setobjectDataNew((prev) => ({
                        ...prev,
                        imageUrl: imageUrl
                    }));
                })
                .catch((err) => {
                    setShowPopup({ show: true, popupStatus: 'Error Uploading Image' })
                })
                .finally(() => {
                    setLoader(false)
                    removePopup()
                });

        } else {
            setobjectDataNew((prev) => ({
                ...prev,
                [type]: e
            }))
        }
    }

    const uploadFileAPI = (file) => {
        return new Promise((resolve, reject) => {
            let imageFormData = new FormData();
            imageFormData.append('uploadfile', file);
            imageFormData.append('type', file?.type?.split("/")?.[1] == "pdf" ? "pdf" : "img");
            imageFormData.append('fileName', file?.name);

            var xhr = new XMLHttpRequest();
            xhr.open('POST', APIS.UPLOAD_ANY_PDF, true);

            xhr.onload = function () {
                if (this.status === 200) {
                    try {
                        const res = JSON.parse(this.response);
                        resolve(res);
                    } catch {
                        resolve(this.response);
                    }
                } else {
                    reject(this.statusText);
                }
            };

            xhr.onerror = function () {
                reject("Network Error");
            };

            xhr.send(imageFormData);
        });
    };




    const saveHandler = (type) => {


        setLoader(true)
        const data = { ...objectDataNew,
            startDate: moment(objectDataNew?.startDate).format("DD-MM-YYYY"),
                endDate: moment(objectDataNew?.endDate).format("DD-MM-YYYY"),
         }


        fetch(APIS.SAVE_UPDATE_BANNER_DETAILS_BY_DATA, {
            method: 'POST',
            headers: POST_HEADER,
            body: JSON.stringify(data)
        })
            .then(res => res.json())
            .then(json => {
                console.log("js",json)
                setShowPopup({ show: true, popupStatus: 'Banner Configurations Saved Successfully' })
                 setobjectDataNew({
                title: "",
                description: "",
                actionType: "",
                actionValue: '',
                priority: '',
                imageUrl: '',
                startDate: '',
                endDate: '',
                isActive: '',
            })
            })
            .catch(err => {
                setShowPopup({ show: true, popupStatus: 'Error Saving Banner Configurations' })
            })
            .finally(() => {
                setLoader(false)
                removePopup()
                setTimeout(()=>{
                    handleEdit("list")
                },5000)
            });


    }

    const closePopup = () => {
        setShowPopup({ show: false, popupStatus: '' })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 3000)
    }



    return (
        <div className="communitySection" style={{ marginTop: '30px' }}>
            <div className='container hoverNone card'>
                {loader ?
                    <Loader />
                    : null}

                {
                    showPopup?.show ?
                        <Popup popupStatus={showPopup?.popupStatus} closePopup={closePopup} />
                        : ''}


                <PiePage
                    totalPage={1}
                    currentPage={1}
                    heading={'Add Banner Config'}
                />


                <div className='row' style={{ marginBottom: '12px' }}>

                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField
                            label="Title"
                            variant="outlined"
                            value={objectDataNew.title}
                            name="title"
                            id="title"
                            type="text"
                            onChange={e => inputChange(e, 'title')}
                            size="small"
                        // required={true}
                        />

                    </div>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField
                            label="Description"
                            variant="outlined"
                            value={objectDataNew.description}
                            name="description"
                            id="description"
                            type="text"
                            onChange={e => inputChange(e, 'description')}
                            size="small"
                        // required={true}
                        />

                    </div>

                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <SelectField
                            value={objectDataNew.actionType}
                            label="Action Type"
                            onChange={e => inputChange(e, 'actionType')}
                            name="actionType"
                            id="actionType"
                            data={actionTypeData}
                            size={'small'}

                        />

                    </div>


                </div>

                <div className='row' style={{ marginBottom: '12px' }}>
                    {
                        objectDataNew?.actionType == "URL" ?
                            <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                                <InputField
                                    label="Action Value"
                                    variant="outlined"
                                    value={objectDataNew.actionValue}
                                    name="actionValue"
                                    id="actionValue"
                                    type="text"
                                    onChange={e => inputChange(e, 'actionValue')}
                                    size="small"
                                // required={true}
                                />
                            </div>
                            : ""}
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>

                        <FormControl fullWidth>
                            <TextField
                                label='Upload Image'
                                type="file"
                                // value={objectDataNew.imageUrl}
                                variant="standard"
                                name="imageUrl"
                                id="imageUrl"
                                onChange={(e) => inputChange(e, "imageUrl")}
                                size="small" inputProps={{ accept: "image/*" }}
                            />
                        </FormControl>

                    </div>

                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <SelectField
                            value={objectDataNew.priority}
                            label="Priority"
                            onChange={e => inputChange(e, 'priority')}
                            name="priority"
                            id="priority"
                            data={priorityData}
                            size={'small'}

                        />

                    </div>
                    {
                        objectDataNew?.actionType !== "URL" ?

                            <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                                <InputField
                                    label="Start Date"
                                    variant="outlined"
                                    value={objectDataNew.startDate}
                                    name="startDate"
                                    id="startDate"
                                    type="date"
                                    onChange={e => inputChange(e, 'startDate')}
                                    size="small"
                                // required={true}
                                />

                            </div>
                            : ''}


                </div>
                <div className='row' style={{ marginBottom: '12px' }}>
                    {
                        objectDataNew?.actionType == "URL" ?
                            <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                                <InputField
                                    label="Start Date"
                                    variant="outlined"
                                    value={objectDataNew.startDate}
                                    name="startDate"
                                    id="startDate"
                                    type="date"
                                    onChange={e => inputChange(e, 'startDate')}
                                    size="small"
                                // required={true}
                                />
                            </div>
                            : ''}

                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField
                            label="End Date"
                            variant="outlined"
                            value={objectDataNew.endDate}
                            name="endDate"
                            id="endDate"
                            type="date"
                            onChange={e => inputChange(e, 'endDate')}
                            size="small"
                        // required={true}
                        />
                    </div>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>

                        <SelectField
                            value={objectDataNew.isActive}
                            label="is Active"
                            onChange={e => inputChange(e, 'isActive')}
                            name="isActive"
                            id="isActive"
                            data={isActiveData}
                            size={'small'}

                        />

                    </div>
                </div>



                <div className='mb-3 mt-2 row' style={{ margin: '20px 0 15px 0' }}>
                    <div className="col-12 text-center">

                        <button className="cred-btn" style={{ fontSize: '16px' }} onClick={e => saveHandler('save')}>Save</button>
                    </div>
                </div>
            </div>
        </div >
    )
}

